import React from 'react';
import cn from 'classnames';

import type { ContainerProps } from '../types';

const Container = (props: ContainerProps, ref: React.Ref<HTMLDivElement>) => {
  const { className, disabled = false, block = false, onClick, ...rest } = props;

  return (
    <div
      {...rest}
      ref={ref}
      className={cn(
        'e-input',
        {
          'e-input--disabled': disabled,
          'e-input--block': block,
        },
        className
      )}
      onClick={disabled ? undefined : onClick}
    />
  );
};

export default React.forwardRef(Container);
